import React from "react";
import ReactDOM from "react-dom/client";
// IST date patch — MUST be first so all date formatting (incl. third-party
// libs and any new code) defaults to Asia/Kolkata, and naive UTC ISO strings
// from the backend are parsed as UTC instead of local time.
import "@/lib/date-ist-patch";
import "@/index.css";
import App from "@/App";
import { registerSW } from "@/lib/registerSW";

// Suppress ResizeObserver loop error (benign browser warning)
const resizeObserverErr = window.addEventListener('error', (e) => {
  if (e.message?.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// PWA — register service worker for installability + auto-update
registerSW();
